module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg_add"
  }, [_c('div', {
    staticClass: "changead"
  }, [_c('div', {
    staticClass: "changeadinput"
  }, [_c('ul', [_vm._l((_vm.lists), function(list, index) {
    return _c('li', {
      key: index
    }, [_c('div', {
      staticClass: "checkbox",
      class: {
        checkboxtrue: list.status == 1
      },
      on: {
        "click": function($event) {
          return _vm.changebox(list, index)
        }
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(list.name))])])
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.sumbitCode()
      }
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.pageback
    }
  }, [_vm._v("取消")])], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-9c1e38b8"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/addMenu.vue
// module id = 545
// module chunks = 1